import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-arrow-white",
  "use": "icon-menu-arrow-white-usage",
  "viewBox": "0 0 141.000000 657.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 141.000000 657.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"icon-menu-arrow-white\">\r\n<metadata>\r\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\r\n</metadata>\r\n<g transform=\"translate(0.000000,657.000000) scale(0.100000,-0.100000)\" fill=\"#e6e8f2\" stroke=\"none\">\r\n<path d=\"M1397 6463 c-22 -366 -153 -819 -353 -1213 -132 -262 -259 -455 -454\r\n-689 -114 -137 -155 -191 -146 -191 3 0 -17 -28 -45 -62 -185 -230 -317 -507\r\n-376 -788 -27 -129 -24 -412 5 -542 26 -118 64 -232 105 -313 65 -130 291\r\n-457 366 -529 22 -22 38 -43 35 -47 -2 -4 33 -53 79 -107 440 -527 737 -1238\r\n786 -1883 4 -57 9 1375 9 3184 1 1808 0 3287 -2 3287 -1 0 -6 -48 -9 -107z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu-arrow-white.svg
// module id = lfma
// module chunks = 60